import { ButtonHTMLAttributes } from "react";
import chatBallon from "../../../assets/icons/chat_ballon.svg";

interface ChatButtonInterface extends ButtonHTMLAttributes<HTMLButtonElement> { }

export const ChatButton = ({ ...rest }: ChatButtonInterface) => {
  // z-50
  return (
    <button
      {...rest}
      className="fixed bottom-12 right-12 flex h-14 w-14 cursor-pointer items-center justify-center rounded-full border-0 bg-primary shadow-lg z-50"
      type="button"
    >
      <img src={chatBallon} alt="" className="h-10 w-10" />
    </button>
  );
};
